const queries = {
  deviceApplications: () => ['device-applications'],
  deviceApplication: (id: number) => ['device-applications', id],
}

export default queries
